module.exports = __webpack_public_path__ + "static/img/crm_service.846428f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crm_service.png
// module id = 4Y1y
// module chunks = 1